{
  "onboarding.cta.complete": "Gå till tjänsten",
  "onboarding.cta.continue": "Fortsätt",
  "onboarding.notifications.disclosure": "Aviseringar är ännu inte aktiva i denna demoversion.",
  "onboarding.notifications.toggle.messages": "Tillåt meddelanden",
  "onboarding.notifications.toggle.system": "Tillåt aviseringar",
  "onboarding.progress.ariaLabel": "Framsteg i introduktionen",
  "onboarding.skip": "Hoppa över",
  "onboarding.step.lakikaveri.body": "När en svår fråga om arbetsrätt eller lön uppstår på jobbet kan du vända dig till Lakikaveri.",
  "onboarding.step.lakikaveri.title": "Juridisk hjälp nära till hands",
  "onboarding.step.notifications.body": "Få aviseringar om meddelanden i tjänsten. Du kan hantera kommunikationsinställningarna i din profil. Kom ihåg att lägga till tjänsten på hemskärmen.",
  "onboarding.step.notifications.title": "Tillåt aviseringar",
  "onboarding.step.training.body": "Få kostnadsfri utbildning och coaching via tjänsten. Du hittar också värdefulla fritidsförmåner.",
  "onboarding.step.training.title": "Utbildning och förmåner",
  "onboarding.step.welcome.body": "Via tjänsten kan du ta kontakt, hitta mångsidiga utbildningsmöjligheter och använda fritidsförmåner.",
  "onboarding.step.welcome.title": "Din tjänst är klar"
}
